<template>
  <v-card style="border: 1px solid #eee; box-shadow: none">
    <div class="d-flex justify-space-between align-center pa-2 grey lighten-4">
      <div>
        <span class="font-weight-medium">Credit/Debit Card</span>
      </div>
      <div>
        <svg
          width="35px"
          height="25px"
          viewBox="0 0 35 25"
          xmlns="http://www.w3.org/2000/svg"
          class="mr-1"
        >
          <title>Visa</title>
          <g
            id="UI-/-Symbols-/-Payments-/-Cards-/-Visa"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="visa">
              <rect
                id="visa-bg"
                fill="#2D4CB3"
                x="0"
                y="0"
                width="35"
                height="25"
                rx="3.31578947"
              ></rect>
              <path
                d="M11.925,16.674 L9.874,16.674 L8.336,10.674 C8.263,10.398 8.108,10.154 7.88,10.039 C7.311,9.75 6.684,9.52 6,9.404 L6,9.173 L9.304,9.173 C9.76,9.173 10.102,9.52 10.159,9.923 L10.957,14.251 L13.007,9.173 L15.001,9.173 L11.925,16.674 Z M16.141,16.674 L14.204,16.674 L15.799,9.173 L17.736,9.173 L16.141,16.674 Z M20.242,11.251 C20.299,10.847 20.641,10.616 21.04,10.616 C21.667,10.558 22.35,10.674 22.92,10.962 L23.262,9.347 C22.692,9.116 22.065,9 21.496,9 C19.616,9 18.248,10.039 18.248,11.481 C18.248,12.578 19.217,13.154 19.901,13.501 C20.641,13.847 20.926,14.078 20.869,14.424 C20.869,14.943 20.299,15.174 19.73,15.174 C19.046,15.174 18.362,15.001 17.736,14.712 L17.394,16.328 C18.078,16.616 18.818,16.732 19.502,16.732 C21.61,16.789 22.92,15.751 22.92,14.193 C22.92,12.231 20.242,12.116 20.242,11.251 L20.242,11.251 Z M29.699,16.674 L28.161,9.173 L26.509,9.173 C26.167,9.173 25.825,9.404 25.711,9.75 L22.863,16.674 L24.857,16.674 L25.255,15.578 L27.705,15.578 L27.933,16.674 L29.699,16.674 Z M26.794,11.193 L27.363,14.02 L25.768,14.02 L26.794,11.193 Z"
                id="visa-logo"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </svg>
        <svg
          width="35px"
          height="25px"
          viewBox="0 0 35 25"
          xmlns="http://www.w3.org/2000/svg"
          class="mr-1"
        >
          <title>Mastercard</title>
          <g
            id="UI-/-Symbols-/-Payments-/-Cards-/-Mastercard"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="mastercard">
              <rect
                id="mastercard-bg"
                fill="#363A47"
                x="0"
                y="0"
                width="35"
                height="25"
                rx="3.31578947"
              ></rect>
              <g
                id="mastercard-logo"
                transform="translate(6.4474, 5.724)"
              >
                <path
                  d="M15.6578947,0 C19.4221513,0 22.4736842,3.09057169 22.4736842,6.90298507 C22.4736842,10.7153985 19.4221513,13.8059701 15.6578947,13.8059701 C13.9708766,13.8059701 12.4270121,13.1852157 11.2368323,12.1569312 C10.0475367,13.1848679 8.50328,13.8059701 6.81578947,13.8059701 C3.05153289,13.8059701 0,10.7153985 0,6.90298507 C0,3.09057169 3.05153289,0 6.81578947,0 C8.50328,0 10.0475367,0.621102206 11.2378517,1.64990292 C12.4270121,0.620754493 13.9708766,0 15.6578947,0 Z"
                  id="Combined-Shape"
                  fill="#EC692C"
                ></path>
                <path
                  d="M6.81578947,0 C8.50328,0 10.0475367,0.621102206 11.2378517,1.64990292 C9.77135476,2.91517361 8.84210526,4.79917212 8.84210526,6.90298507 C8.84210526,9.00679803 9.77135476,10.8907965 11.2368323,12.1569312 C10.0475367,13.1848679 8.50328,13.8059701 6.81578947,13.8059701 C3.05153289,13.8059701 0,10.7153985 0,6.90298507 C0,3.09057169 3.05153289,0 6.81578947,0 Z"
                  id="Combined-Shape"
                  fill="#D92F22"
                ></path>
                <path
                  d="M15.6578947,0 C19.4221513,0 22.4736842,3.09057169 22.4736842,6.90298507 C22.4736842,10.7153985 19.4221513,13.8059701 15.6578947,13.8059701 C13.9706333,13.8059701 12.4265667,13.1850365 11.2363173,12.1564861 C12.7029723,10.8894929 13.6315789,9.00607019 13.6315789,6.90298507 C13.6315789,4.79989996 12.7029723,2.91647724 11.2383727,1.6503533 C12.4265667,0.620933606 13.9706333,0 15.6578947,0 Z"
                  id="Combined-Shape"
                  fill="#ECA43A"
                ></path>
              </g>
            </g>
          </g>
        </svg>
        <svg
          width="35px"
          height="25px"
          viewBox="0 0 35 25"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>AMEX</title>
          <g
            fill="none"
            fill-rule="evenodd"
          >
            <rect
              width="35"
              height="25"
              rx="3.3158"
              fill="#367CC7"
            ></rect>
            <path
              d="m30.745 16.989h-1.5365v-0.7738h1.341s0.48896 0.056849 0.48896-0.26614c0-0.30271-0.73102-0.27918-0.73102-0.27918s-1.1913 0.10247-1.1913-1.0008c0-1.0975 1.0762-1.0349 1.0762-1.0349h1.6527v0.78466h-1.3302s-0.46066-0.09161-0.46066 0.23935c0 0.27737 0.62749 0.2379 0.62749 0.2379s1.3179-0.096317 1.3179 0.91574c0 1.0848-0.84907 1.1815-1.1503 1.1815-0.064797 0-0.10427-0.0043452-0.10427-0.0043452zm-7.6658 0.0054315v-3.3545h2.6928v0.77887h-1.8244v0.51671h1.7789v0.76257h-1.7789v0.56921h1.8244v0.72709h-2.6928zm4.6215-0.0054315h-1.5369v-0.7738h1.347s0.48337 0.056849 0.48337-0.26614c0-0.30271-0.73102-0.27918-0.73102-0.27918s-1.1913 0.10247-1.1913-1.0008c0-1.0975 1.0762-1.0349 1.0762-1.0349h1.6583v0.78466h-1.3354s-0.46103-0.09161-0.46103 0.23935c0 0.27737 0.62675 0.2379 0.62675 0.2379s1.3187-0.096317 1.3187 0.91574c0 1.0848-0.84907 1.1815-1.1503 1.1815-0.06517 0-0.10427-0.0043452-0.10427-0.0043452zm-11.643 0.0057936h-0.75374l-0.91536-0.99576-0.92057 0.99576h-0.52397-2.6876v-3.366h2.6876 0.4547l0.98984 1.0689 0.99579-1.0631h0.66213v-0.0057935h2.0947s1.0937-0.11949 1.0937 0.98852c0 0.98961-0.36346 1.297-1.4792 1.297h-0.84609v1.0805h-0.85205zm-1.0818-1.6541 1.0706 1.1707v-2.337l-1.0706 1.1663zm-3.8502 0.92624h1.8184l0.85205-0.92624-0.85205-0.92153h-1.8184v0.51671h1.7726v0.76257h-1.7726v0.56849zm5.7841-1.229h0.8919c0.25919 0 0.4722-0.14194 0.4722-0.31828 0-0.17562-0.21301-0.31828-0.4722-0.31828h-0.8919v0.63656zm4.9037 1.9622v-0.65394s-0.035378-0.51164-0.57647-0.51164h-0.83939v1.1656h-0.86397v-3.3602h2.0955s1.0934-0.13072 1.0934 0.98345c0 0.58008-0.48337 0.78466-0.48337 0.78466s0.41448 0.19336 0.41448 0.76149v0.83065h-0.84013zm-1.4159-1.956h0.8919c0.25919 0 0.47183-0.14194 0.47183-0.31828 0-0.17634-0.21264-0.31828-0.47183-0.31828h-0.8919v0.63656zm-0.65058-2.6437h0.86843v-3.3711h-0.86843v3.3711zm-6.6879-0.011587v-3.3599h2.6936v0.7843h-1.8244v0.51743h1.7786v0.76185h-1.7786v0.56921h1.8244v0.72709h-2.6936zm-1.3526 3.62e-4v-2.3199l-1.0818 2.3199h-0.70793l-1.0878-2.3087v2.3087h-0.75411-0.11507-0.83455l-0.29941-0.705h-1.5767l-0.30499 0.705h-0.94403l1.433-3.3606h1.2144l1.3123 3.0876v-3.0876h1.3641l0.94962 2.0868 0.94366-2.0868h1.3641v3.3606h-0.87476zm-6.0891-1.5639h0.84013l-0.42007-1.0005-0.42007 1.0005zm23.05 1.5639-1.3689-2.2461v2.2461h-0.74256-0.1389-0.81071l-0.30499-0.705h-1.5771l-0.29978 0.705h-0.79433-0.14375-0.41448s-1.1619-0.16512-1.1619-1.5863c0-1.8652 1.3179-1.7913 1.3634-1.8025l1.0647 0.028243v0.75642l-0.87402 0.011225s-0.57014 0-0.63978 0.73361c-0.007448 0.08473-0.011544 0.16149-0.0108 0.23355 0.0033516 1.1359 0.99766 0.78358 1.0304 0.77271l1.0703-2.5075h1.2081l1.2948 3.0478v-3.0478h1.2204l1.3526 2.212v-2.212h0.86955v3.3606h-1.192zm-4.5749-1.5639h0.8405l-0.41448-1.0005-0.42602 1.0005zm-5.6121 1.5639v-0.65394s-0.034261-0.51164-0.57536-0.51164h-0.84013v1.1656h-0.86359v-3.3606h2.0951s1.0934-0.13072 1.0934 0.98381c0 0.58008-0.48337 0.78466-0.48337 0.78466s0.42007 0.19336 0.42007 0.76185v0.83029h-0.84609zm-1.4155-1.956h0.8919c0.25919 0 0.47183-0.1423 0.47183-0.31864 0-0.17598-0.21264-0.31828-0.47183-0.31828h-0.8919v0.63693z"
              fill="#fff"
            ></path>
          </g>
        </svg>
      </div>
    </div>
    <div class="pa-4">
      <div class="card-label">Card number</div>
      <div class="input-wrapper">
        <div id="card-number"></div>
      </div>
      <div class="d-flex">
        <div class="pr-2 flex-grow-1">
          <div class="card-label">Expiry</div>
          <div class="input-wrapper">
            <div id="card-expiry"></div>
          </div>
        </div>
        <div class="pl-2 flex-grow-1">
          <div class="card-label">CVC</div>
          <div class="input-wrapper">
            <div id="card-cvc"></div>
          </div>
        </div>
      </div>
      <div class="card-label">Name on card</div>
      <div class="input-wrapper">
        <input
          v-model="cardName"
          placeholder="Enter name"
        />
      </div>
      <div
        v-if="errorMsg"
        id="card-error"
      >
        {{ errorMsg }}
      </div>
      <v-btn
        depressed
        class="mt-4"
        color="primary"
        height="48"
        @click="createToken"
        block
        :loading="localLoading"
        >{{ btnLabel }}</v-btn
      >
      <div
        v-if="localLoading"
        class="mt-2 pa-2 processing-card"
      >
        <div class="body-2 text-center">
          Card is being processed, don't close or reload page.
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "CreditCardForm",
  props: {
    btnLabel: {
      default: "Purchase",
    },
    loading: {
      default: false,
    },
  },
  data: () => ({
    token: null,
    cardNumber: null,
    cardExpiry: null,
    cardCvc: null,
    cardName: "",
    errorMsg: "",
  }),
  mounted() {
    // Style Object documentation here: https://stripe.com/docs/js/appendix/style
    const style = {
      base: {
        color: "black",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    }
    this.cardNumber = this.stripeElements.create("cardNumber", { style })
    this.cardNumber.mount("#card-number")
    this.cardExpiry = this.stripeElements.create("cardExpiry", { style })
    this.cardExpiry.mount("#card-expiry")
    this.cardCvc = this.stripeElements.create("cardCvc", { style })
    this.cardCvc.mount("#card-cvc")
  },
  beforeDestroy() {
    this.cardNumber.destroy()
    this.cardExpiry.destroy()
    this.cardCvc.destroy()
  },
  computed: {
    stripeElements() {
      return this.$stripe.elements()
    },
    localLoading: {
      get() {
        return this.loading
      },
      set(val) {
        this.$emit("update:loading", val)
      },
    },
  },
  methods: {
    async createToken() {
      this.errorMsg = ""
      this.localLoading = true
      if (this.cardName.replace(" ", "").length === 0) {
        this.errorMsg = "Name is required"
        this.localLoading = false
        return
      }
      const { token, error } = await this.$stripe.createToken(this.cardNumber, {
        name: this.cardName,
      })
      if (error) {
        // handle error here
        this.errorMsg = error.message
        this.localLoading = false
        return
      }

      this.$emit("submit", token)
    },
  },
}
</script>

<style scoped>
#card-error {
  color: red;
}

.card-label {
  color: #444444;
  margin-bottom: 4px;
}

.input-wrapper {
  border-radius: 4px;
  border: 1px solid #bbb;
  margin-bottom: 8px;
  padding: 8px;
}

.input-wrapper input {
  outline: none;
  width: 100%;
}

.input-wrapper input::placeholder {
  color: #aab7c4;
}

.processing-card {
  background-color: #ccdef8;
  border-radius: 4px;
}
</style>
